import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { usePrefersReducedMotion } from "@cinch-nx/shared-ui";
import { Box, Skeleton } from "@mui/material";
import cx from "classnames";
import styles from "./hub-card-skeleton.module.css";
export const HubCardSkeleton = ({ featured , hasDate =false  })=>{
    const prefersReducedMotion = usePrefersReducedMotion();
    return /*#__PURE__*/ _jsxs(Box, {
        className: cx(styles.root, {
            [styles.featured]: featured
        }),
        children: [
            /*#__PURE__*/ _jsx(Skeleton, {
                sx: {
                    marginRight: "16px"
                },
                animation: prefersReducedMotion ? false : "wave",
                variant: "rectangular",
                width: featured ? 400 : 250,
                height: featured ? 253 : 158
            }),
            /*#__PURE__*/ _jsxs(Box, {
                children: [
                    /*#__PURE__*/ _jsx(Skeleton, {
                        animation: prefersReducedMotion ? false : "wave",
                        variant: "text",
                        height: 24,
                        width: hasDate ? 400 : 125
                    }),
                    /*#__PURE__*/ _jsx(Skeleton, {
                        animation: prefersReducedMotion ? false : "wave",
                        variant: "text",
                        height: 24,
                        width: hasDate ? 125 : 400
                    })
                ]
            })
        ]
    });
};
